// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1530":"86d0ad6c","5548":"74ef9348","5551":"a488b892","7804":"89d005f9","8691":"86d0ad6c"}[chunkId] + ".chunk.css";
};